import React, { useState } from 'react';
import ProfileTitle from '../ProfileTitle';
import InstitutionInfoDetails from './InstitutionInfoDetails';
import './InstitutionInfoDetails.scss';

interface IInstitutionDetails {
  payload: any;
  index?: number;
}

const InstitutionDetails = ({
  payload,
  index,
}: IInstitutionDetails) => {
  const [isInstitutionDetailHidden, setIsInstitutionDetailHidden] = useState(false);

  return (
    <div className="institution-details-cover">
      <ProfileTitle
        name="Institution Details"
        index={index}
        onClick={() => setIsInstitutionDetailHidden(!isInstitutionDetailHidden)}
      />
      {isInstitutionDetailHidden && (
        <div className="institution-form-cover">
          <InstitutionInfoDetails
            payload={payload?.userRtDetail}
          />
        </div>
      )}
    </div>
  );
};

export default InstitutionDetails;
